import React from 'react';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import TargetKpiSettingContainer from '../../containers/targetmng/TargetKpiSettingContainer';

/**
 * KPI 정의 관리 페이지 (관리자용)
 */
const TargetKpiSettingPage = () => {
  return (
    <div>
      <BreadcrumbsContainer 
        title="목표 관리/KPI 정의" 
        icon="settings" 
      />
      <TargetKpiSettingContainer />
    </div>
  );
};

export default TargetKpiSettingPage;
